export const appsUserInfoUserDeletionRecordDatatable = "/apps/user_info/user_deletion_record_datatable";
